//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** The step in the Account Entry block. */
export const AccountEntryStep = {
    /** The registration step. */
    Registration: 0,

    /** The duplicate person selection step. */
    DuplicatePersonSelection: 1,

    /** The existing account step. */
    ExistingAccount: 2,

    /** The confirmation sent step. */
    ConfirmationSent: 3,

    /** The completed step. */
    Completed: 4,

    /** The passwordless confirmation sent step. */
    PasswordlessConfirmationSent: 5
} as const;

/** The step in the Account Entry block. */
export const AccountEntryStepDescription: Record<number, string> = {
    0: "Registration",

    1: "Duplicate Person Selection",

    2: "Existing Account",

    3: "Confirmation Sent",

    4: "Completed",

    5: "Passwordless Confirmation Sent"
};

/** The step in the Account Entry block. */
export type AccountEntryStep = typeof AccountEntryStep[keyof typeof AccountEntryStep];
